import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

function AppSnackbar({ alerta, onClose, autoHideDuration = 4000 }) {
  return (
    <Snackbar
      open={alerta.visivel}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity={alerta.tipo} variant="filled" sx={{ width: '100%' }}>
        {alerta.mensagem}
      </Alert>
    </Snackbar>
  );
}

export default AppSnackbar;
